export const saveAuthData = (data) => {
  const expiryTime =
    new Date().getTime() + data.expiresIn;

  localStorage.setItem("token", data.token);
  localStorage.setItem("role", data.role);
  localStorage.setItem("username", data.username);
  localStorage.setItem("fullName", data.fullName || "");
  localStorage.setItem("profilePicture", data.profilePicture || "");
  localStorage.setItem(
    "assignedInterfaces",
    JSON.stringify(Array.isArray(data.assignedInterfaces) ? data.assignedInterfaces : [])
  );
  localStorage.setItem("tokenExpiry", expiryTime);
};

export const isAuthenticated = () => {
  const token =
    localStorage.getItem("token");

  const expiry =
    localStorage.getItem("tokenExpiry");

  if (!token || !expiry) {
    return false;
  }

  const now =
    new Date().getTime();

  if (now > Number(expiry)) {
    logoutUser();
    return false;
  }

  return true;
};

export const getRole = () => {
  return localStorage.getItem("role");
};

// Returns the person's display name if we have one (captured from their
// Microsoft account), otherwise falls back to their username/email so
// there's always something sensible to show.
export const getDisplayName = () => {
  const fullName = localStorage.getItem("fullName");
  return fullName && fullName !== "" ? fullName : localStorage.getItem("username");
};

// Returns the array of module names ("Food Committee", "Vehicles", etc.)
// this user is allowed to see. Admin / Super Admin accounts don't use
// this list - they always get full access, checked separately via role.
export const getAssignedInterfaces = () => {
  try {
    const raw = localStorage.getItem("assignedInterfaces");
    const parsed = JSON.parse(raw || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
};

// True if this user (by role or by assigned interface) is allowed to
// see the given module. Admin and Super Admin always pass.
export const hasInterfaceAccess = (moduleName) => {
  const role = getRole();

  if (role === "admin" || role === "superadmin") {
    return true;
  }

  return getAssignedInterfaces().includes(moduleName);
};

export const logoutUser = () => {
  localStorage.clear();
  window.location.href = "/";
};